import React, { useState } from 'react';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import RadioButton from '@/common/components/RadioButton';

function BasicSelectionDialog({ close, options, onSelect, selectedOption, title }) {
    const [active, setActive] = useState(selectedOption);

    return (
        // @ts-ignore
        <Docked>
            <DialogTitle>{title}</DialogTitle>
            {/*@ts-ignore*/}
            <DialogBody>
                {options
                    .map(option => (
                        // @ts-ignore
                        <RadioButton
                            key={option.key}
                            onClick={() => {
                                onSelect(option.key);
                                setActive(option);
                                setTimeout(() => close(), 200);
                            }}
                            active={option.key === active.key}
                        >
                            {option.value}
                        </RadioButton>
                    ))
                    .toArray()}
            </DialogBody>
        </Docked>
    );
}

export default BasicSelectionDialog;
